/* eslint-disable react-hooks/exhaustive-deps */
import { getTodayWithoutHourInMillis } from "components/CustomDatePicker/utils/helpers";
import { getMinutesOfToday } from "components/CustomTimePicker/utils";
import { useEffect, useState } from "react";

const useDisableForCheckTimeButton = ({ eventData }) => {
	const [disabled, setDisabled] = useState(false);
	const [isFinalizedCheckTime, setIsFinalizedCheckTime] = useState(false);
	useEffect(() => {
		if (!eventData.isLoaded) return;
		fillDisabled();
		const intervalId = setInterval(() => fillDisabled(), 1000);
		return () => clearInterval(intervalId);
	}, [eventData.isLoaded]);
	function getNowDate() {
		// Para TEST
		// return 14 * 60;
		return getMinutesOfToday();
	}
	function getToday() {
		// Para TEST
		// return new Date(2023, 10, 8).getTime();
		return getTodayWithoutHourInMillis();
	}
	function isInSchedule(nowDate) {
		const nowTime = getNowDate();
		const { date, time } = eventData.value.schedule;
		return (
			// Durante la fecha y 15 min. antes de la hora de inicio y antes de la hora finalización
			nowDate === date && nowTime >= time.start - 15 && nowTime < time.end
		);
	}
	function isFinalizedEvent(nowDate) {
		const nowTime = getNowDate();
		const { date, time } = eventData.value.schedule;
		return nowDate > date || (nowDate === date && nowTime >= time.end);
	}
	function fillDisabled() {
		const nowDate = getToday();
		setDisabled(!isInSchedule(nowDate));
		setIsFinalizedCheckTime(isFinalizedEvent(nowDate));
	}
	return {
		disabled,
		isFinalizedCheckTime,
	};
};

export default useDisableForCheckTimeButton;
